import { confirmPasswordReset, createUserWithEmailAndPassword, deleteUser, EmailAuthProvider, reauthenticateWithCredential, sendPasswordResetEmail, signInWithEmailAndPassword, signOut as so, updateProfile } from 'firebase/auth'
import { auth } from "../firebase"
export const signInWithMail = async ({email, password}) =>{
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password)
    return {status: 'success', user:userCredential.user}
  } catch (error) {
    console.log(error)
    return {status: 'failed', error:error}
  }
}
export const signOut = async () => {
  try {
    await so(auth)
  } catch (error) {
    console.log(error)
  }
}

export const updateProfileImage = async (url) => {
  try {
    await updateProfile(auth.currentUser, {
      photoURL: url
    })
  } catch (error) {
    console.log(error)
  }
} 

export const createNewUser = async (email, password) =>{
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password)
    return {status: 'success', user:userCredential.user}
  } catch (error) {
    console.log(error)
    return {status: 'failed', error:error}
  }
}

export const deleteUserProfile = async () => {
  try {
    
    await deleteUser(auth.currentUser)
  } catch (error) {
    console.log(error)
  }
}

export const reauthentucate = async ({email, password}) => {
  try {
    const credential = EmailAuthProvider.credential(email, password)
    const res = await reauthenticateWithCredential(auth.currentUser, credential)
    return {status:'success'}
  } catch (error) {
    console.log(error)
    return {status:'failed', error:error}
  }
}

export const sendNewPasswordEmail = async (email, url) =>{
  try {
    await sendPasswordResetEmail(auth, email, {url:`${url}/signin`})
  } catch (error) {
    console.log(error)
  }
}

export const resetPassword = async (oobCode, newPassword) =>{
  
  try {
    console.log(oobCode, newPassword)
    await confirmPasswordReset(auth, oobCode, newPassword)
    return {status:'success'}
  } catch (error) {
    console.log(error)
    return {status:'failed', error:error}
  }
}